import Component from "../../lib/component";
import shoelaceLightStyles from "@shoelace-style/shoelace/dist/themes/light.css";
import "@shoelace-style/shoelace/dist/components/rating/rating.js";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
import iconStar from "./assets/icon__star.svg";

// Inject Shoelace light theme styles into the document head
const shoelaceStyleTag = document.createElement("style");
shoelaceStyleTag.textContent = shoelaceLightStyles;
document.head.appendChild(shoelaceStyleTag);

setBasePath("/shoelace/assets"); // Set the base path to the folder you copied Shoelace's assets to

export const StarRatingConfig = {
  componentTypeKey: "StarRating",
  baseHtmlClass: "star_rating",
  selector: ".star_rating",

  datasetConfigKey: "star_rating__config",

  value: 0,
  label: "Rating",
  max: 5,
  precision: 0.5,
  readonly: true,
};

export class StarRating extends Component {
  static get config() {
    return StarRatingConfig;
  }

  constructor(id_or_element) {
    super({ element: id_or_element, config: StarRating.config });

    this.element.innerHTML = getInitialContent();

    this.setDatasetConfig(StarRating.config.datasetConfigKey);
    this.value = this.getDatasetConfigValue("value") || StarRating.config.value;
    this.max = this.getDatasetConfigValue("max") || StarRating.config.max;
    this.label = this.getDatasetConfigValue("label") || StarRating.config.label;
    this.precision =
      this.getDatasetConfigValue("precision") || StarRating.config.precision;
    this.readonly =
      this.getDatasetConfigValue("readonly") || StarRating.config.readonly;
    this.prefix = this.getDatasetConfigValue("prefix");
    this.suffix = this.getDatasetConfigValue("suffix");

    this.slRatingElement = this.element.querySelector("sl-rating");

    this.prefixElement = createPrefixElement(this);
    this.suffixElement = createSuffixElement(this);

    this.render();
  }

  render() {
    this.element.style.cssText =
      "display: flex; align-items: center; gap: 0.25em;";
    if (this.slRatingElement) {
      if (this.value) this.slRatingElement.value = this.value;
      if (this.max) this.slRatingElement.max = this.max;
      if (this.label) this.slRatingElement.label = this.label;
      if (this.precision) this.slRatingElement.precision = this.precision;
      this.slRatingElement.readonly = this.readonly;
      this.slRatingElement.getSymbol = () => iconStar;
    }
    if (this.prefixElement) {
      this.prefixElement.style.cssText = "font-size: 0.80em; font-weight: bold; white-space: nowrap;";
      this.prefixElement.innerText = this.prefix;
    }
    if (this.suffixElement) {
      this.suffixElement.style.cssText = "font-size: 0.80em; font-weight: bold; white-space: nowrap;";
      this.suffixElement.innerText = this.suffix;
    }
  }
}

function getInitialContent() {
  return `
    <sl-rating label="Rating" value="0" precision="${StarRating.config.precision}" max="${StarRating.config.max}"></sl-rating>
`;
}


function createPrefixElement(starRating) {
  if (!starRating.prefix) return null;
  const prefix = document.createElement("span");
  prefix.classList.add("star_rating__prefix");
  prefix.innerText = starRating.prefix;
  starRating.element.insertBefore(prefix, starRating.element.firstChild);
  return prefix;
}

function createSuffixElement(starRating) {
  if (!starRating.suffix) return null;
  const suffix = document.createElement("span");
  suffix.classList.add("star_rating__suffix");
  suffix.innerText = starRating.suffix;
  starRating.element.appendChild(suffix);
  return suffix;
}
